import {
  getAuthorizeInfo,
  getUsersCurrentInfo,
  getUsersInfoByCode,
  getAccessTokenByCodeApi,
  getAccessTokenApi,
  getSuperiorDeptApi,
} from "@/api/modules/userAuth";
import {
  urlEncode,
  getUrlParamsObj,
  delUrlParams,
  removeCodeFromUrl,
} from "@/scripts/utils";
import store from "@/store/index";
import vue from "@/main";

/**
 * 根据场景类型接入对应权限
 * @param params 当前模块权限相关配置对象
 */
export const setUserAuth = async function(params) {
  const { authType, authFn } = params;
  if (authType === "webAuthLogin") {
    const corpId = global.APP_CONFIG.corpId;
    const appId = global.APP_CONFIG.appId;
    await getWebAuthCode(corpId, appId);
  } else if (authType === "scanCodeAuthLogin") {
    // 扫码授权登录，待接入...
  } else if (authType === "customAuthLogin") {
    authFn && authFn(global.APP_CONFIG);
  }
};

/**
 * 企微网页授权获取授权码
 * @param corpId 应用所属企业id
 * @param appId 当前应用id
 */
export const getWebAuthCode = async function(corpId, appId) {
  const code = getUrlParamsObj().code;
  const redirectUri = urlEncode(window.location.href);
  const oauth2Url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${corpId}&redirect_uri=${redirectUri}&response_type=code&scope=snsapi_base&state=1#wechat_redirect`;
  if (code == null || code === "") {
    window.location.href = oauth2Url;
  } else {
    await getAuthorizeInfoFn(code, appId);
  }
};

/**
 * 企微授权登录获取登录凭证token
 * @param code 授权链接返回的授权码
 * @param appId 当前应用id
 * @param oauth2Url 授权链接
 */
export const getAuthorizeInfoFn = async function(code, appId) {
  getAuthorizeInfo({ code, appId }).then(
    async (res) => {
      console.log("authorizeInfo", res);
      if (res.code === 0) {
        store.commit("userAuth/authorizeInfo", res.data);
        const qs = JSON.parse(JSON.stringify(vue.$route.query)); // 深拷贝
        delete qs.code;
        delete qs.state;
        if (!vue.$route.name) {
          location.href = delUrlParams(location.href, ["code", "state"]);
        } else {
          vue.$router.replace({ query: qs });
        }
      }
    },
    (err) => {
      window.console.log(err, "authorizeInfo-err");
    }
  );
};

/**
 * 企微网页授权登录获取当前用户信息
 * @param oauth2Url 授权链接
 */
export const getUser = function() {
  return new Promise((resolve, reject) => {
    getUsersCurrentInfo().then(
      (res) => {
        if (res.code === 0) {
          store.commit("userAuth/usersCurrentInfo", res.data);
        }
        resolve(res);
      },
      (err) => {
        window.console.log(err, "usersCurrentInfo-err");
        reject(err);
      }
    );
  });
};

/**
 * 企微网页进页面就要获取顾问ID
 */
export const getQwUserId = async function() {
  const corpId = global.APP_CONFIG.corpId;
  const appId = global.APP_CONFIG.appId;
  const code = getUrlParamsObj().code;
  console.log("code!==null");
  console.log(location.href);
  const redirectUri = urlEncode(window.location.href);
  const oauth2Url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${corpId}&redirect_uri=${redirectUri}&response_type=code&scope=snsapi_base&state=1#wechat_redirect`;
  if (code == null || code === "") {
    console.log("code===null  12312");
    window.location.href = oauth2Url;
  } else {
    await getAuthorizeInfo({ code, appId }).then(
      (res) => {
        if (res.code === 0) {
          store.commit("userAuth/authorizeInfo", res.data);
          console.log(JSON.parse(JSON.stringify(vue.$route.query)));
          const qs = JSON.parse(JSON.stringify(vue.$route.query)); // 深拷贝
          delete qs.code;
          delete qs.state;
          const newUrl = delUrlParams(location.href, ["code", "state"]);
          console.log(vue.$route.name);
          if (!vue.$route.name) {
            console.log("到了If location");
            location.href = newUrl;
          } else {
            vue.$router.replace({ query: qs });
          }
        }
      },
      (err) => {
        window.console.log(err, "getQwUserId-err");
      }
    );
  }
};

/**
 * 根据场景类型接入对应权限
 * @param params 当前模块权限相关配置对象
 */
export const setUserAuthOfCode = async (params) => {
  const { corpId, appId } = params;
  const code = getUrlParamsObj().code;
  const redirectUri = urlEncode(window.location.href);
  const oauth2Url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${corpId}&redirect_uri=${redirectUri}&response_type=code&scope=snsapi_base&state=1#wechat_redirect`;
  if (code == null || code === "") {
    window.location.replace(oauth2Url);
  } else {
    // 企微 通过code获取用户信息
    const res = await getUsersInfoByCode({
      appId: appId,
      code: code,
      tenantId: 120000,
    });
    if (res.code === 0) {
      store.commit("userAuth/usersCurrentInfo", res.data);
      sessionStorage.setItem("userInfo", JSON.stringify(res.data));

      // 获取用户上级部门
      const deptRes = await getSuperiorDeptApi({
        deptId: res.data.mainDepartment,
      });
      sessionStorage.setItem("deptInfo", JSON.stringify(deptRes.data));

      // 去除URL中的code参数
      setTimeout(() => {
        removeCodeFromUrl();
      }, 500);
    }
  }
};

/**
 * 微信环境 获取登录人openid 测试
 * @param params 当前模块权限相关配置对象
 */
export const setUserOfCodeWxDev = async (params) => {
  const { appId } = params;
  const code = getUrlParamsObj().code;
  const redirectUri = urlEncode(window.location.href);
  const oauth2Url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${redirectUri}&response_type=code&scope=snsapi_base&state=1#wechat_redirect`;

  if (code == null || code === "") {
    window.location.replace(oauth2Url);
  } else {
    // 微信 通过code获取用户信息
    const res = await getAccessTokenByCodeApi({
      code: code,
    });
    sessionStorage.setItem("userInfo", JSON.stringify(res));
  }
};

/**
 * 微信环境 获取登录人openid 生产
 * @param params 当前模块权限相关配置对象
 */
export const setUserOfCodeWxPrd = async (params) => {
  const { appId } = params;
  const code = getUrlParamsObj().code;
  const redirectUri = urlEncode(window.location.href);
  const oauth2Url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${redirectUri}&response_type=code&scope=snsapi_base&state=1#wechat_redirect`;

  if (code == null || code === "") {
    window.location.href = oauth2Url;
  } else {
    // 微信 通过code获取用户信息
    const res = await getAccessTokenApi({
      code: code,
    });
    sessionStorage.setItem("userInfo", JSON.stringify(res));
  }
};
